import { build, version } from '../constants/version';

export default function getApiUrlParams() {
  return `?av=${version}.${build}&v=1.0.0&app_id=affiliate&platform=web`;
}
